import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import TwoFactorRecoveryAdminForm from './TwoFactorRecoveryAdminForm';
import { sendTwoFactorAdminRecoveryEmail } from '../../../actions/twoFactorRecovery';
import { getIsAdminRecovering, getAdminRecoveryEmailAttempted, getAdminRecoveryEmailExpired, getAdminRecoveryEmailSent, getIsRecoveryEmailToAdminInErrorState, getAdminRecoveryAdmins
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../../selectors/TwoFactorRecovery';
import { getEmail, getToken } from '../../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
class TwoFactorRecoveryPage extends Component {
  constructor(...args) {
    super(...args);
    this.handleSubmit = event => {
      event.preventDefault();
      const {
        token
      } = this.props;
      this.props.sendTwoFactorAdminRecoveryEmail(token);
    };
  }
  componentDidMount() {
    const {
      token
    } = this.props;
    if (token === null) {
      this.props.history.push('/');
    }
  }
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "TWO_FACTOR_ADMIN_RECOVERY_LOAD",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        flexDirection: "column",
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsx(View, {
          maxInlineSize: "500px",
          children: /*#__PURE__*/_jsx(TwoFactorRecoveryAdminForm, Object.assign({
            onSubmit: this.handleSubmit
          }, this.props))
        })
      })
    });
  }
}
TwoFactorRecoveryPage.propTypes = {
  history: PropTypes.object.isRequired,
  token: PropTypes.string,
  email: PropTypes.string.isRequired,
  isRecovering: PropTypes.bool.isRequired,
  recoveryAttempted: PropTypes.bool.isRequired,
  recoveryExpired: PropTypes.bool.isRequired,
  recoverySent: PropTypes.bool.isRequired,
  isRecoveryEmailInErrorState: PropTypes.bool.isRequired,
  adminsForRecovery: PropTypes.array.isRequired,
  sendTwoFactorAdminRecoveryEmail: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  email: getEmail(state),
  isRecovering: getIsAdminRecovering(state),
  recoveryAttempted: getAdminRecoveryEmailAttempted(state),
  recoveryExpired: getAdminRecoveryEmailExpired(state),
  recoverySent: getAdminRecoveryEmailSent(state),
  isRecoveryEmailInErrorState: getIsRecoveryEmailToAdminInErrorState(state),
  token: getToken(state),
  adminsForRecovery: getAdminRecoveryAdmins(state)
});
const reduxConnect = connect(mapStateToProps, {
  sendTwoFactorAdminRecoveryEmail
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof TwoFactorRecoveryPage' is... Remove this comment to see the full error message
export default reduxConnect(TwoFactorRecoveryPage);